"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHealthCheckTimeValue = void 0;
const helpers_1 = require("../../../helpers");
const getScheduleSelectedIndex_1 = require("./getScheduleSelectedIndex");
const getHealthCheckTimeValue = (isDailyScheduleEnabled, isWeeklyScheduleEnabled, isMonthlyScheduleEnabled, isYearlyScheduleEnabled, dailyScheduleFirstRow, weeklyScheduleTime, monthlyScheduleTime, yearlyScheduleTime) => {
    const defaultTime = '12:00 PM';
    if (isDailyScheduleEnabled) {
        const times = helpers_1.getTimes();
        const selectedHours = getScheduleSelectedIndex_1.getScheduleSelectedIndex(dailyScheduleFirstRow);
        const result = selectedHours.map((val) => times[val]);
        return result.pop() || defaultTime;
    }
    else if (isWeeklyScheduleEnabled) {
        return weeklyScheduleTime;
    }
    else if (isMonthlyScheduleEnabled) {
        return monthlyScheduleTime;
    }
    else if (isYearlyScheduleEnabled) {
        return yearlyScheduleTime;
    }
    return defaultTime;
};
exports.getHealthCheckTimeValue = getHealthCheckTimeValue;
//# sourceMappingURL=getHealthCheckTimeValue.js.map